import PropTypes from "prop-types";
import { Empty, Spin } from "antd";
import cn from "../../../utilities/tailwind-merge";
import CategoryCard from "./CategoryCard";

function CategoryList({ categories, loading, t, getActionItems, onActionClick, actionLoadingId }) {
    if (loading && categories.length === 0) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <Spin />
            </div>
        );
    }

    if (!loading && categories.length === 0) {
        return (
            <div className="py-10">
                <Empty description={t("rates.noCategories")} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
        );
    }

    return (
        <div className="relative min-h-[120px]">
            {loading && !actionLoadingId ? (
                <div
                    className="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-white/70"
                    aria-busy="true"
                    aria-live="polite">
                    <Spin />
                </div>
            ) : null}
            <div
                className={cn(
                    "flex flex-col gap-3",
                    loading && !actionLoadingId && "pointer-events-none select-none opacity-50",
                )}
                aria-hidden={loading && !actionLoadingId}>
                {categories.map((category) => (
                    <CategoryCard
                        key={category.categoryId || category._id}
                        category={category}
                        t={t}
                        actionItems={getActionItems(category)}
                        onActionClick={onActionClick}
                        menuDisabled={
                            actionLoadingId != null &&
                            String(actionLoadingId) === String(category.categoryId)
                        }
                        isActionLoading={
                            actionLoadingId != null &&
                            String(actionLoadingId) === String(category.categoryId)
                        }
                    />
                ))}
            </div>
        </div>
    );
}

CategoryList.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    getActionItems: PropTypes.func.isRequired,
    onActionClick: PropTypes.func.isRequired,
    actionLoadingId: PropTypes.string,
};

export default CategoryList;
